export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5529.90ec97f8.jpg";